export default __webpack_public_path__ + "static/media/login_img.7a806f90.png";